export default "__VITE_ASSET__BGvixK8O__"